export interface IToTopArrow {
  el: {
    topButton: HTMLElement
  }
  init: () => void
  scrollFunction: () => void
  topFunction: () => void
}

const ToTopArrow: IToTopArrow = {
  el: {
    topButton: document.querySelector('.to-top-button'),
  },

  init() {
    ToTopArrow.scrollFunction()

    window.onscroll = function () {
      ToTopArrow.scrollFunction()
    }

    if (this.el.topButton) {
      this.el.topButton.addEventListener('click', () => {
        ToTopArrow.topFunction()
      })
    }
  },

  scrollFunction() {
    if (
      (document.body.scrollTop > 20 && window.innerWidth > 1200) ||
      (document.documentElement.scrollTop > 20 && window.innerWidth > 1200)
    ) {
      this.el.topButton.style.display = 'block'
    } else {
      this.el.topButton.style.display = 'none'
    }
  },

  topFunction() {
    document.body.scrollTop = 0 // For Safari
    document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
  },
}

export default ToTopArrow
